import type { SdeWorkbookClient, SdeWorkbookClientError } from "@services/clients/SdeWorkbookClient";
import type { TaskEitherTs } from "@ps-bridge/interop";
import { taskEitherOf } from "@utils/effects/branded";

const workbookSignature = new Uint8Array([0x50, 0x4b, 0x03, 0x04]);

export class StubSdeWorkbookClient implements SdeWorkbookClient {
    generateWorkbook(_file: File): TaskEitherTs<SdeWorkbookClientError, Blob> {
        return taskEitherOf(new Blob([workbookSignature], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
    }
}
